import { createReducer } from 'typesafe-actions';

import { TCoreAction, EModalActionTypes, ICoreState } from '@/store/types/modals.types';

const initialState: ICoreState = {
  isOpen: false,
};

export const modalReducer = createReducer<ICoreState, TCoreAction>(initialState)
  .handleType(EModalActionTypes.OPEN_MODAL, (state, action) => ({
    ...state,
    isOpen: true,
    currentModal: { keyModal: action.keyModal, props: action.props, dialogProps: action.dialogProps },
    action: undefined,
  }))

  .handleType(EModalActionTypes.CLOSE_MODAL, (state, action) => ({
    ...state,
    isOpen: false,
    currentModal: undefined,
    action: action?.action,
  }));
